export const stripTrailingZeros = (num) =>
	num
		.toString()
		.split('')
		.reverse()
		.reduce(
			(sum, char) => (char === '0' && sum === '' ? '' : `${char}${sum}`),
			'',
		);
